<template>
    <div id="contenedor-main-contrato-album">
        <album
        :reportesFisicos="getReportesFisicos"
        :contrato="getContrato"
        :modulo="modulo">
        </album>

    </div>
</template>

<script>
import Album from '@/components/administracion/album/Main.vue';
import CONTRATO_REPORTES_FISICOS from '@/graphql/querys/administracion/ejecucion/reportesFisicos/contratoReportesFisicos.gql';
import CONTRATO from '@/graphql/querys/administracion/contratos/contrato.gql';

export default {
  name: 'MainContratoAlbum',
  props: {
    modulo: {
      type: String,
      required: false,
      default: '',
    },
  },
  components: {
    Album,
  },
  data() {
    return {};
  },
  apollo: {
    contratoReportesFisicos: {
      query: CONTRATO_REPORTES_FISICOS,
      variables() {
        return {
          idContrato: this.$route.params.idContrato,
        };
      },
    },
    contrato: {
      query: CONTRATO,
      variables() {
        return {
          id: this.$route.params.idContrato,
        };
      },
    },
  },
  computed: {
    getReportesFisicos() {
      if (!this.contratoReportesFisicos) return [];
      return this.contratoReportesFisicos;
    },
    getContrato() {
      if (!this.contrato) return {};
      return this.contrato;
    },

  },

};
</script>
